


















import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";

@Component({
  async beforeRouteEnter(to, _from, next) {
    try {
      await vxm.results.bindEvent(to.params.game);
      vxm.app.setPageLoaded();
      document.title = vxm.results.game.title;
      next();
    } catch (err) {
      vxm.app.setPageLoaded();
      document.title = "Not found";
      next();
    }
  },

  async destroyed() {
    await vxm.results.unbind();
  },

  watch: {
    user: {
      immediate: true,
      async handler() {
        await vxm.results.checkInstructorAccess();
      }
    },
    subscriptionActive: {
      immediate: true,
      async handler(subscriptionActive: boolean) {
        if (!subscriptionActive) {
          await vxm.results.unbind();
        }
      }
    }
  }
})
export default class ResultsBase extends Vue {
  get user() {
    return vxm.auth.user;
  }

  get game() {
    return vxm.results.game;
  }

  get subscriptionActive() {
    return vxm.results.teams.length < 100;
  }
}
